import { CheckCircle } from '@emotion-icons/material/CheckCircle'
import { CloseCircle } from '@emotion-icons/ionicons-sharp/CloseCircle'
import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { Colors, Shapes } from 'src/components/theme'

const FeatureList = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-height: 150px;
  gap: ${Shapes.spacing[2]}px;
`
const Feature = styled.div`
  display: flex;
  align-items: center;
  gap: ${Shapes.spacing[2]}px;
`

type SubscriptionFeatureListProps = {
  features: string[]
  type: 'gained' | 'lost'
}
export const SubscriptionFeatureList = (props: SubscriptionFeatureListProps) => {
  const { features, type = 'lost' } = props

  return (
    <FeatureList>
      {features.map((feature, index) => (
        <Feature key={index}>
          {type === 'gained' ? (
            <CheckCircle size={20} color={Colors.blueDark} />
          ) : (
            <CloseCircle size={20} color={Colors.redDark} />
          )}
          <Typography variant="title2l" color={Colors.textMedium}>
            {feature}
          </Typography>
        </Feature>
      ))}
    </FeatureList>
  )
}
